export enum EmbeddingName {
  PyMDE_3D_40N = 'pymde',
  GGVec_10D_40N_Order2 = 'ggvec',
  PyMDE_4D_40N = 'pymde_4d_40n',
  PyMDE_4D_100N = 'pymde_4d_100n',
}
